<template>
  <header>
    <div class="title">
      <div class="logo"></div>
    </div>
    <div class="nav-list">
      <ul class="nav_list2">
        <li v-for="(item,index) in iconList" :key="index"
        @click="activeFn(index)"
        :class="{ active: active_idx == index }">
          <a :href="item.link"target="_blank">
            <i :class="item.icon"></i>
            <span>{{item.name}}</span>
          </a>
        </li>
      </ul>
      <div class="right-logo">
        <i class="iconfont icon-yonghu"></i>
        <span>用户中心</span>
      </div>
    </div>
  </header>
</template>

<script>
import ApiSystem from '@/service/api.service'
import Cookies from 'vue-cookie'

export default {
  name: "comHeader",
  data() {
    return {
      active_idx: 0,
      iconList: [{
        name: '素材库',
        icon: 'iconfont icon-sucaikulishangchuan',
        link: '#'
      }, {
        name: '帮助中心',
        icon: 'iconfont icon-bangzhuzhongxin',
        link: 'help.html'
      }, {
        name: '新媒体学院',
        icon: 'iconfont icon-xueyuan',
        link: 'help.html'
      }]
    };
  },
  created () {
    this.getToken()
  },
  methods: {
    activeFn(idx) {
      this.active_idx = idx;
    },
    getToken () {
      const token = Cookies.get('token')
      if (!token) {
        const getsTokens = new ApiSystem()
        getsTokens.testToken()
          .then(({data}) => {
            Cookies.delete('token')
            Cookies.set('token', data.data.token, 1)
          }, (error) => {
           this.$notify.error(error.message)
          })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/icon-font/iconfont.css';

header {
  position: absolute;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;
  width: 100%;
  padding: 0 1%;
  height: 60px;
  color: #555555;
  box-sizing: border-box;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  .nav-list{
    color: #7e7e7e;
  }
  .nav,
  .title,
  .right-logo {
    display: flex;
    align-items: center;
  }
  .right-logo{
    i{
      margin-right: 10px;
    }
  }
  .nav_list2 {
    pointer-events: initial;
    display: flex;
    float: left;
    position: relative;
    margin-right: 50px;
    // right: -10%;
    li {
      cursor: pointer;
      margin-right: 20px;
      display: flex;
      float: left;
      align-items: center;
      a {
        display: flex;
        float: left;
        align-items: center;
        color: #7e7e7e;
      }
      i {
        margin-right: 10px;
      }
      &:hover {
        color: $color;
        a {
          color: $color;
        }
      }
    }
  }

  .nav_list1 {
    margin-left: 20%;
  }
  .logo {
    pointer-events: initial;
    width: 155px;
    height: 40px;
    margin: 0 18px;
    background-image: url(../assets/images/logo.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% auto;
  }

  .active {
    color: $color;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-header.vue